export const LABEL_REJECT_DEFAULT_REASON = "Неизвестная причина";
export const LABEL_REJECT_REASON_CLOSE = "Закрытие модального окна";
export const LABEL_REJECT_REASON_UNMOUNT = "Удаление родительского компонента";
